import React, { useEffect, useState } from 'react';
import $api from '../http';
import '../css/missed-traffic.css';

const MissedTraffic = ({ store }) => {
    const [stats, setStats] = useState([]);
    const [refreshDate, setRefreshDate] = useState();
    const [loading, setLoad] = useState(true);
    const [error, setError] = useState(null);

    // Стейт для выбора сортировки: 'merchant' или 'total'
    const [sortBy, setSortBy] = useState('merchant');
    const [onlyTotal, setOnlyTotal] = useState(false);

    /* заголовок страницы */
    useEffect(() => {
        store?.setPageTitle('Анализ трафика');
    }, [store]);

    /* загрузка данных */
    useEffect(() => {
        (async () => {
            try {
                const { data } = await $api.get('/missed_traffic');
                console.log(data);
                setRefreshDate(data.generatedAt);
                // Убеждаемся, что data.stats — это массив
                const statsData = Array.isArray(data.stats) ? data.stats : [];
                // свежее — сверху
                setStats(statsData.reverse());
            } catch (e) {
                setError(e.message || 'Ошибка загрузки');
            } finally {
                setLoad(false);
            }
        })();
    }, []);

    if (loading) return <p>Loading…</p>;
    if (error)   return <p style={{ color:'crimson' }}>{error}</p>;

    /* ───────────────────────── helpers ───────────────────────── */

    // Суммируем массив объектов по выбранному числовому полю
    const sumField = (arr, field) =>
        arr.reduce((s, x) => s + (x?.[field] || 0), 0);

    // Наша старая sumBreakdown НЕ собирала rangeDistribution
    // Теперь пишем новую, которая будет с range-данными:
    function sumBreakdownWithRange(merchantsList) {
        // Cтруктура map: trafficType -> {
        //   amount: number, missedCount: number,
        //   rangeMap: Map<range, { amount: number, missedCount: number }>
        // }
        const trafficMap = new Map();

        merchantsList.forEach(m => {
            // Для каждого merchant breakdown
            if (!Array.isArray(m.breakdown)) return;
            m.breakdown.forEach(b => {
                const t = b.trafficType;
                // Ищем/создаём объект в map
                let trafficObj = trafficMap.get(t);
                if (!trafficObj) {
                    trafficObj = {
                        amount: 0,
                        missedCount: 0,
                        rangeMap: new Map() // для rangeDistribution
                    };
                    trafficMap.set(t, trafficObj);
                }
                // Суммируем общий amount
                trafficObj.amount += b.amount ?? 0;
                // Если у вас есть b.missedCount — тоже можно суммировать:
                trafficObj.missedCount += b.missedCount ?? 0;

                // В rangeDistribution
                if (Array.isArray(b.rangeDistribution)) {
                    b.rangeDistribution.forEach(rd => {
                        const range = rd.range;
                        // rangeObj: { amount, missedCount }
                        let rangeObj = trafficObj.rangeMap.get(range);
                        if (!rangeObj) {
                            rangeObj = { amount: 0, missedCount: 0 };
                            trafficObj.rangeMap.set(range, rangeObj);
                        }
                        rangeObj.amount       += rd.amount ?? 0;
                        rangeObj.missedCount  += rd.missedCount ?? 0;
                    });
                }
            });
        });

        // Теперь из trafficMap делаем массив нужного вида
        return Array.from(trafficMap.entries()).map(([trafficType, obj]) => {
            // Превращаем rangeMap в массив
            const rangeDistribution = Array.from(obj.rangeMap.entries())
                .map(([range, rObj]) => ({
                    range,
                    amount: rObj.amount,
                    missedCount: rObj.missedCount
                }));
            return {
                trafficType,
                amount: obj.amount,
                missedCount: obj.missedCount,
                rangeDistribution
            };
        });
    }

    // Старая функция для Orders breakdown на TOTAL, она без range.
    // Оставляем как есть, т.к. в ordersBreakdown нет rangeDistribution.
    const sumOrdersBreakdown = (list, key) => {
        const map = new Map();
        list.forEach(item => {
            const bArr = Array.isArray(item[key]) ? item[key] : [];
            bArr.forEach(b => {
                const t = b.trafficType;
                const prev = map.get(t) || { ordersCount:0, ordersAmount:0 };
                prev.ordersCount  += b.ordersCount;
                prev.ordersAmount += b.avgOrderAmount * b.ordersCount;
                map.set(t, prev);
            });
        });

        // приводим к массиву
        return Array.from(map, ([trafficType, v]) => ({
            trafficType,
            ordersCount: v.ordersCount,
            avgOrderAmount: v.ordersCount ? v.ordersAmount / v.ordersCount : 0
        }));
    };

    /* ───────────────────────── render ───────────────────────── */

    // Предопределённый порядок диапазонов для сортировки
    const rangeOrder = ['<1000', '1000-5000', '5000-10000', '>10000'];

    return (
        <div className="missed-traffic-wrapper">

            <div style={{
                display: 'flex',
                flexDirection: "column",
                alignItems: 'flex-start',
                marginBottom: '16px',
                width: "100%"
            }}>
                <h3 style={{marginRight: '20px'}}>
                    {`Обновлено ${new Date(refreshDate).toLocaleString()}`}
                </h3>

                {!store.user.agent
                    ?
                    <div>
                        {/* Селект для выбора типа сортировки */}
                        <label style={{fontWeight: 'bold', marginRight: '8px'}}>Сортировка:</label>
                        <select
                            style={{marginRight: 'auto'}}
                            value={sortBy}
                            onChange={(e) => setSortBy(e.target.value)}
                        >
                            <option value="merchant">По алфавиту</option>
                            <option value="total">По сумме</option>
                        </select>
                        <div className={"user-creator-checkbox-container"} style={{marginTop: '15px'}}>
                            <input
                                type="checkbox"
                                id="gross-check-deny-checkbox"
                                checked={onlyTotal}
                                onClick={(e) => {

                                    setOnlyTotal(prev => !prev)
                                }}
                            />
                            <label htmlFor="gross-check-deny-checkbox">Только тотал</label>
                        </div>
                    </div>
                    :
                    null
                }

            </div>
            <div style={{overflowX: 'auto', width: '100%' }}>
            <table className="transaction-table">
                <thead>
                <tr>
                    <th>Дата</th>
                    <th>Мерчант</th>
                    <th>Пропущено</th>
                    <th>Конверсия [%]</th>
                    <th>Средний чек [₽]</th>
                    <th>Total [₽]</th>
                    <th>Подробно</th>
                </tr>
                </thead>

                <tbody>
                {stats.map((day) => {
                    const merchantsArr = Array.isArray(day.merchants) ? day.merchants : [];

                    // Сортируем мерчантов
                    const sortedMerchants = [...merchantsArr];
                    if (sortBy === 'merchant') {
                        sortedMerchants.sort((a, b) =>
                            a.merchant.localeCompare(b.merchant)
                        );
                    } else if (sortBy === 'total') {
                        sortedMerchants.sort((a, b) =>
                            b.totalAmount - a.totalAmount
                        );
                    }

                    // агрегаты суток
                    const missedTotal  = sumField(merchantsArr, 'missedCount');
                    const ordersTotal  = sumField(merchantsArr, 'ordersCount');
                    const totalAmount  = day.totalAmount || 0;

                    const convTotal =
                        ordersTotal + missedTotal
                            ? ordersTotal / (ordersTotal + missedTotal)
                            : null;

                    const ordersAmountTotal = merchantsArr.reduce(
                        (s, m) => s + (m.avgOrderAmount * m.ordersCount || 0),
                        0
                    );
                    const avgTotal = ordersTotal
                        ? ordersAmountTotal / ordersTotal
                        : 0;

                    // (NEW) Берём разбивку с диапазонами для TOTAL
                    const missedBDwithRange = sumBreakdownWithRange(merchantsArr);
                    // А для orders можно оставить прежний sumBreakdown
                    const ordersBD = sumOrdersBreakdown(merchantsArr, 'ordersBreakdown');

                    return (
                        <React.Fragment key={day.day}>
                            {/* Заголовок даты */}
                            <tr className="day-row">
                                <td>{day.day}</td>
                                <td colSpan={5}></td>
                                <td style={{ textAlign:'right', fontWeight:600 }}>
                                    {Number(totalAmount).toLocaleString('ru-RU')}
                                </td>
                            </tr>

                            {/* Мерчанты */}
                            {!onlyTotal && !store.user.agent && sortedMerchants.map((m) => (
                                <tr key={`${day.day}-${m.merchant}`}>
                                    <td></td>
                                    <td>{m.merchant}</td>
                                    <td>{m.missedCount}</td>
                                    <td>
                                        {m.conversion != null
                                            ? (m.conversion * 100).toFixed(1) + '%'
                                            : '—'}
                                    </td>
                                    <td>{(m.avgOrderAmount ?? 0).toFixed(2)}</td>
                                    <td>{(m.totalAmount ?? 0).toLocaleString('ru-RU')}</td>
                                    <td>
                                        <div className="breakdown-wrapper">
                                            {/* Пропущенные платежи */}
                                            <table className="inner-table missed-subtable">
                                                <thead>
                                                <tr>
                                                    <th>Тип трафика</th>
                                                    <th>Пропущено ₽</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {Array.isArray(m.breakdown) && m.breakdown.map((b, bIndex) => {
                                                    // Сортируем rangeDistribution у мерчанта
                                                    let ranges = [];
                                                    if (Array.isArray(b.rangeDistribution)) {
                                                        ranges = b.rangeDistribution.slice().sort((r1, r2) =>
                                                            rangeOrder.indexOf(r1.range) - rangeOrder.indexOf(r2.range)
                                                        );
                                                    }
                                                    // rowClass — жирная линия между типами
                                                    const rowClass = bIndex > 0 ? 'traffic-type-row' : '';

                                                    return (
                                                        <React.Fragment key={b.trafficType}>
                                                            <tr className={rowClass}>
                                                                <td>{b.trafficType}</td>
                                                                <td style={{textAlign:'right'}}>
                                                                    {b.amount?.toLocaleString('ru-RU')}
                                                                </td>
                                                            </tr>
                                                            {ranges.length > 0 && (
                                                                <tr>
                                                                    <td colSpan={2} className="range-cell">
                                                                        <div className="range-wrapper">
                                                                            <table className="range-table">
                                                                                <thead>
                                                                                <tr>
                                                                                    <th>Диапазон</th>
                                                                                    <th>Сумма</th>
                                                                                    <th>Кол-во</th>
                                                                                </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                {ranges.map(rd => (
                                                                                    <tr key={rd.range}>
                                                                                        <td>{rd.range}</td>
                                                                                        <td style={{ textAlign:'right' }}>
                                                                                            {rd.amount?.toLocaleString('ru-RU')}
                                                                                        </td>
                                                                                        <td style={{ textAlign:'right' }}>
                                                                                            {rd.missedCount}
                                                                                        </td>
                                                                                    </tr>
                                                                                ))}
                                                                                </tbody>
                                                                            </table>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                                </tbody>
                                            </table>

                                            {/* Заказы (orders) */}
                                            <table className="inner-table orders-subtable">
                                                <thead>
                                                <tr>
                                                    <th>Тип трафика</th>
                                                    <th>Количество</th>
                                                    <th>Срений чек ₽</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {Array.isArray(m.ordersBreakdown) && m.ordersBreakdown.map(o => (
                                                    <tr key={o.trafficType}>
                                                        <td>{o.trafficType}</td>
                                                        <td>{o.ordersCount}</td>
                                                        <td style={{textAlign:'right'}}>
                                                            {o.avgOrderAmount.toFixed(2)}
                                                        </td>
                                                    </tr>
                                                ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                            {/* Итого по суткам */}
                            <tr className="total-row">
                                <td></td>
                                <td><strong>TOTAL</strong></td>
                                <td><strong>{missedTotal}</strong></td>
                                <td>
                                    <strong>
                                        {convTotal != null
                                            ? (convTotal * 100).toFixed(1) + '%'
                                            : '—'}
                                    </strong>
                                </td>
                                <td><strong>{avgTotal.toFixed(2)}</strong></td>
                                <td>
                                    <strong>
                                        {Number(totalAmount).toLocaleString('ru-RU')}
                                    </strong>
                                </td>
                                <td>
                                    <div className="breakdown-wrapper">

                                        {/* Пропущенные итоги (теперь тоже range) */}
                                        <table className="inner-table missed-subtable">
                                            <thead>
                                            <tr>
                                                <th>Тип трафика</th>
                                                <th>Пропущено ₽</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {missedBDwithRange.map((b, i) => {
                                                // Сортируем итоговый rangeDistribution
                                                let ranges = b.rangeDistribution.slice().sort((r1, r2) =>
                                                    rangeOrder.indexOf(r1.range) - rangeOrder.indexOf(r2.range)
                                                );
                                                // Аналогично — жирная линия между разными trafficType
                                                const rowClass = i > 0 ? 'traffic-type-row' : '';

                                                return (
                                                    <React.Fragment key={b.trafficType}>
                                                        <tr className={rowClass}>
                                                            <td>{b.trafficType}</td>
                                                            <td style={{textAlign:'right'}}>
                                                                {b.amount.toLocaleString('ru-RU')}
                                                            </td>
                                                        </tr>
                                                        {ranges.length > 0 && (
                                                            <tr>
                                                                <td colSpan={2} className="range-cell">
                                                                    <div className="range-wrapper">
                                                                        <table className="range-table">
                                                                            <thead>
                                                                            <tr>
                                                                                <th>Диапазон</th>
                                                                                <th>Сумма</th>
                                                                                <th>Кол-во</th>
                                                                            </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {ranges.map(rd => (
                                                                                <tr key={rd.range}>
                                                                                    <td>{rd.range}</td>
                                                                                    <td style={{ textAlign:'right' }}>
                                                                                        {rd.amount.toLocaleString('ru-RU')}
                                                                                    </td>
                                                                                    <td style={{ textAlign:'right' }}>
                                                                                        {rd.missedCount}
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                            </tbody>
                                        </table>

                                        {/* Заказные итоги (orders) */}
                                        <table className="inner-table orders-subtable">
                                            <thead>
                                            <tr>
                                                <th>Тип трафика</th>
                                                <th>Количество</th>
                                                <th>Средний чек ₽</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {ordersBD.map(o => (
                                                <tr key={o.trafficType}>
                                                    <td>{o.trafficType}</td>
                                                    <td>{o.ordersCount}</td>
                                                    <td style={{textAlign:'right'}}>
                                                        {o.avgOrderAmount.toFixed(2)}
                                                    </td>
                                                </tr>
                                            ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </React.Fragment>
                    );
                })}
                </tbody>
            </table>
            </div>
        </div>
    );
};

export default MissedTraffic;
